import { Timeslot } from "@raskrask-dk/raskrask-utils";
import {Action} from "../../../action/action";
import type CalendarState from "../calendarState";

export const NEXT_STATE = "NEXT_STATE";
export class Next extends Action<typeof NEXT_STATE, undefined> {
  readonly type = NEXT_STATE;
  private _state: CalendarState;

  constructor(state: CalendarState) {
    super(state);
    this._state = state;
  }

  public isValid(): boolean {
    if (!this.isDoable()) return false;

    const {goal, partner, basisType, serviceType, date, time} = this.state.getData();

    if (!goal || !basisType || !goal || !serviceType || !partner || !date || !time) return false;

    const basisTypeHasGoal = basisType.goals.some(goal.equals);
    const goalHasServiceType = goal.services.some(serviceType.equals);

    const isTimeSlotExistOnServiceDatePartnerCombination = partner
      .getTimeslotsForDate(date, serviceType)
      .some((timeSlotTime: Timeslot) => time == timeSlotTime.start);

    return basisTypeHasGoal && goalHasServiceType && isTimeSlotExistOnServiceDatePartnerCombination;
  }

  public isDoable(): boolean {
    const {partner, date, time, goal, serviceType, basisType} = this.state.getData();
    const isRequiredValuesSet = this.allHasValues(partner, date, time, goal, serviceType, basisType);

    return isRequiredValuesSet;
  }
}
